const $wakelock = document.querySelector('.js-wakelock');

let wakeLock = null;

// De browser geeft het wake lock zelf vrij zodra het document niet meer
// zichtbaar is, dus alleen `released` vertelt of de kookstand nog actief is.
function isActive() {
    return wakeLock !== null && !wakeLock.released;
}

async function requestWakeLock() {
    if (isActive()) {
        return;
    }

    try {
        wakeLock = await navigator.wakeLock.request('screen');
    } catch (err) {
        // Geweigerd, bijvoorbeeld bij een lage accustand: checkbox terugzetten
        // zodat de kookstand niet ten onrechte aan lijkt te staan.
        wakeLock = null;
        $wakelock.checked = false;
    }
}

async function releaseWakeLock() {
    if (isActive()) {
        try {
            await wakeLock.release();
        } catch (err) {
            // al vrijgegeven door de browser
        }
    }

    wakeLock = null;
}

if ($wakelock) {
    if ('wakeLock' in navigator) {
        $wakelock.addEventListener('change', (e) => {
            if (e.target.checked) {
                requestWakeLock();
            } else {
                releaseWakeLock();
            }
        });

        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible' && $wakelock.checked) {
                requestWakeLock();
            }
        });
    } else {
        // Geen ondersteuning, o.a. in iOS-webapps op het beginscherm.
        const $toggle = $wakelock.closest('label') || $wakelock;

        $toggle.classList.add('d-none');
    }
}
